import React, { useState, useEffect} from 'react';
import ImageButton from './imageButton';

const Feedback = ({channel, server_host, uid, username, roomId, is_coaching_room=false, is_owner=false, is_coach=false}) => {

  const [isFeedbackRunning, setIsFeedbackRunning] = useState(false);
  const [feedbackDuration, setFeedbackDuration] = useState(0);
  const [isFeedbackMaster, setIsFeedbackMaster] = useState(false);
  const [isRipRunning, setIsRipRunning] = useState(false);
  const [isPauseRunning, setIsPauseRunning] = useState(false);


  // to begin with, restitution time is 1/4 of introspection time
    
  
  useEffect(() => {
    channel.on('feedback status', status => {
      if (roomId === status['room']) {
        setIsFeedbackRunning((status['duration'] > 0))
        const is_master = status['originator'] === uid
        if (! is_master) {
          setFeedbackDuration(status['duration'])
        }
      }
    })
    channel.on('rip status', status => {
      if (roomId === status['room']) {
        setIsRipRunning((status['duration'] > 0))
      }
  })
  channel.on('pause status', status => {
    if (roomId === status['room']) {
      setIsPauseRunning((status['duration'] > 0))
    }
  })
}, [feedbackDuration, isPauseRunning, isFeedbackMaster, isFeedbackRunning, isRipRunning, channel, roomId, uid]);

    useEffect(() => {
        let interval;
    
        if (isFeedbackRunning && isFeedbackMaster) {
          interval = setInterval(() => {
            const nduration = feedbackDuration - 1000
            setFeedbackDuration(nduration);
            if (nduration <= 0) {
              setIsFeedbackRunning(false)
            }
            channel.emit('feedback running', 
              {
                'room' : roomId, 
                'duration' : nduration, 
                'originator' : uid,
                'username' : username
              })
          }, 1000);
        }
        return () => clearInterval(interval);
      
  }, [isFeedbackRunning, roomId, feedbackDuration, channel, isFeedbackMaster, username, uid]);
    
      const startTimer = () => {
        if (feedbackDuration < 60000) {
          alert("Le temps minimal de feedback est de soixante secondes")
          return
        }
        setIsFeedbackRunning(true);
        setIsFeedbackMaster(true)
        channel.emit('feedback running', 
          {
            'room' : roomId, 
            'duration' : feedbackDuration, 
            'originator' : uid,
            'username' : username,
          })
      };
    
      const addTimer = () => {
        setFeedbackDuration(feedbackDuration + 60000);
      };

      const addTimer10 = () => {
        setFeedbackDuration(feedbackDuration + 600000);
      };
    
      const subTimer = () => {
        const d = feedbackDuration - 60000; 
        setFeedbackDuration(Math.max(0, d))
      };

      const subTimer10 = () => {
        const d = feedbackDuration - 600000; 
        setFeedbackDuration(Math.max(0, d))
      };
    
      const stopTimer = () => {
        setIsFeedbackRunning(false);
        setFeedbackDuration(0)

      };
    
      const resetTimer = () => {
        setFeedbackDuration(180000);
      };
    

    const rtime = feedbackDuration / 1000

    let protocol = process.env.REACT_APP_PROTOCOL
    if (protocol === undefined){
      protocol = "http"
    }



    if (! isRipRunning && ! isPauseRunning && rtime > 0){
        const minutes = Math.floor(rtime  / 60);
        const seconds = rtime % 60;
    
        return (
            <div className='rip' title='Introspection' >
              <div>
                {
                feedbackDuration > 59000 && is_coach && is_owner && !isFeedbackRunning  ? (
                <ImageButton
                    url={`${protocol}://${server_host}:3050/images/play-circle.svg`} size='small' 
                    onClick={startTimer} title="Seul le coach parle " color='lightgreen'/>
                ) : (' ')}
                { is_coach && is_owner && is_owner  && ! isRipRunning && ! isPauseRunning   ? (
                    <ImageButton
                    url={`${protocol}://${server_host}:3050/images/plus-circle.svg`}  title="+ 10'" size='small' 
                onClick={addTimer10} />) : ( ' ') }
                { is_coach && is_owner && is_owner  && ! isRipRunning && ! isPauseRunning   ? (
                  <ImageButton
                    url={`${protocol}://${server_host}:3050/images/plus.svg`}  title="+ 1'" size='small' 
                 onClick={addTimer}/> ) : (' ')}
                 { is_coach && is_owner && is_owner && ! isRipRunning && ! isPauseRunning   ? (
                  <ImageButton
                    url={`${protocol}://${server_host}:3050/images/minus.svg`}  title="- 1'" size='small' 
                  onClick={subTimer}/> ) : (' ')}
                  { is_coach && is_owner && is_owner && ! isRipRunning && ! isPauseRunning ? (
                    <ImageButton
                    url={`${protocol}://${server_host}:3050/images/minus-circle.svg`}  title="- 10' ou annuler" size='small' 
                   onClick={subTimer10}/> ) : (' ')}
            </div>
            Feedback&nbsp;<br/>
            { feedbackDuration > 0 ? (
                  minutes.toString().padStart(2, '0')) : (' ')}:
            { feedbackDuration > 0 ? (
                  seconds.toString().padStart(2, '0')) : (' ')}
          </div>
        )
    } else {
        return (
            <div className="feedback" title="feedback">
                { is_coach && is_owner && is_coaching_room && ! isRipRunning && !isPauseRunning ? (
                <ImageButton title="Feedback of the coach" color='#dfd046' size='small'
                    url={`${protocol}://${server_host}:3050/images/key.svg`}
                onClick={() => resetTimer(180000)}/>
                ) : ' ' }
            </div>
        )
    }
}

export default Feedback;